import React, { useState } from 'react';
import { Button, Divider, Stack, TextField, Typography } from '@mui/material';

/** Action block: optional cancellation reason → cancel order. */
export default function CancelAction({ busy, onSubmit }) {
  const [reason, setReason] = useState('');
  return (
    <>
      <Divider sx={{ my: '14px' }} />
      <Typography variant='body2' fontWeight='700' mb='6px'>Cancel</Typography>
      <Stack direction='row' spacing='8px'>
        <TextField
          size='small'
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder='Reason (optional)'
          sx={{ flex: 1 }}
        />
        <Button
          disabled={busy === 'Cancel'}
          color='error' variant='outlined'
          onClick={() => onSubmit(reason)}
        >
          Cancel order
        </Button>
      </Stack>
    </>
  );
}
